import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { AppService } from "../app.service";

export const countryResolver: ResolveFn<any> = (route, state) => {
  const appService = inject(AppService);

  return appService.getNonOrgCodeListsByGroupName(
   
    "COUNTRY"
  );
};
